import {
  CommonActions,
  NavigationProp,
  ParamListBase,
} from "@react-navigation/native";

export function navigateToHomeFeed(
  navigation: NavigationProp<ParamListBase>,
) {
  navigation.dispatch(
    CommonActions.reset({
      index: 0,
      routes: [
        {
          name: "home",
          params: {
            screen: "feed",
            params: {
              screen: "feedList",
            },
          },
        },
      ],
    }),
  );
}
